import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile"
}
const _hoisted_2 = { class: "text-capitalize-first mb-0" }
const _hoisted_3 = { class: "block userinfo" }
const _hoisted_4 = { class: "d-flex flex-row justify-content-start align-items-center" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "username" }
const _hoisted_9 = { class: "email" }
const _hoisted_10 = {
  class: "buttons",
  style: {"display":"none"}
}
const _hoisted_11 = { class: "btn btn-outline-secondary" }
const _hoisted_12 = { class: "text-capitalize-first" }
const _hoisted_13 = { class: "block user-league" }
const _hoisted_14 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_15 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "league-name" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "buttons" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "d-flex flex-column gap-xs" }
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = { class: "d-flex justify-content-between leagues-stat" }
const _hoisted_26 = { class: "font-monospace d-flex align-items-center" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_28 = { class: "d-flex justify-content-between leagues-stat" }
const _hoisted_29 = { class: "font-monospace" }
const _hoisted_30 = { class: "d-flex justify-content-between leagues" }
const _hoisted_31 = { class: "oauth-accounts" }
const _hoisted_32 = { class: "header ms-0 mb-0" }
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "block oauth-account" }
const _hoisted_35 = { class: "provider" }
const _hoisted_36 = ["alt", "src"]
const _hoisted_37 = { class: "text-capitalize-first" }
const _hoisted_38 = {
  key: 0,
  class: "text-capitalize-first text-primary"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "text-capitalize-first" }

import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed, onMounted} from "vue";
import UserDTO from "@/models/UserDTO";
import {recalculationInLabelText} from "@/service/DateHelper";
import { loadGoogleScript } from '@/composables/useGoogleSignIn'
import { loadFacebookScript } from '@/composables/useFacebookSignIn'
import { loadAppleScript } from '@/composables/useAppleSignIn'
import {api} from "@/service/APIClient";
import TokenOAuthRequestDTO from "@/models/request/TokenOAuthRequestDTO";
import {reactive} from "@vue/reactivity";
import LeagueProgressBar from "@/components/LeagueProgressBar.vue";
import {numberFormatter} from "@/service/NumberFormatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const store = useStore()
const router = useRouter()

const state = reactive({
  googleClient: null as any
});

const user = computed((): UserDTO|null => {
  return store.getters.getUser
})

const nextCalcLabel = computed(() => {
  if (!user.value) {
    return '';
  }

  return recalculationInLabelText(user.value?.userLeague.nextCalcAt)
})

const connect = (provider: string) => {
  switch (provider) {
    case 'GOOGLE':
      return state.googleClient.requestAccessToken();
    case 'APPLE':
      return connectApple();
    case 'FACEBOOK':
      return connectFacebook();
  }
}

const connectApple = async () => {
  try {
    const data = await AppleID.auth.signIn()
    const idToken = data.authorization.id_token
    await api.call.token.oauthConnect({ type: 'APPLE', payload: idToken } as TokenOAuthRequestDTO)
    await store.dispatch('updateUser')
  } catch (e) {
  }
}

const connectFacebook = () => {
  window.FB.login(async (response:any) => {
    if (response.authResponse?.signedRequest) {
      await api.call.token.oauthConnect({ type: 'FACEBOOK', payload: response.authResponse.signedRequest } as TokenOAuthRequestDTO)
      await store.dispatch('updateUser')
    }
  }, { scope: 'public_profile,email' })
}

onMounted(async () => {
  await loadGoogleScript();
  state.googleClient = window.google.accounts.oauth2.initTokenClient({
    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    callback: async (response: any) => {

      await api.call.token.oauthConnect({type: 'GOOGLE', payload: response.access_token} as TokenOAuthRequestDTO)
      await store.dispatch('updateUser')
    },
  });

  await loadFacebookScript(process.env.VUE_APP_FACEBOOK_APP_ID as string);
  await loadAppleScript(process.env.VUE_APP_APPLE_CLIENT_ID as string);
});

const logout = () => {
  store.dispatch('logout')
  window.location.href = '/';
}

return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('profile')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (user.value?.avatarUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: user.value?.avatarUrl
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(user.value?.userLabel), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(user.value?.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('edit')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  alt: "league",
                  src: `/img/leagues/${user.value?.userLeague.league}.png`
                }, null, 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`leagues.titles.${user.value?.userLeague.league}`)), 1),
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("img", { src: "/img/timer.svg" }, null, -1)),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createElementVNode("span", {
                    class: "recal-text",
                    innerHTML: nextCalcLabel.value
                  }, null, 8, _hoisted_20)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'leagueDescriptions'}))),
                class: "btn btn-outline-secondary"
              }, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('about')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('bets')), 1),
                _createElementVNode("span", _hoisted_26, [
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    src: "/img/coins/gold_coin.svg",
                    style: {"height":"14px","margin-right":"4px"}
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(numberFormatter).formatNumber(user.value?.userLeague.betSum)) + " / " + _toDisplayString(_unref(numberFormatter).formatNumber(user.value?.userLeague.nextBetSum)), 1)
                ])
              ]),
              _createVNode(LeagueProgressBar, {
                class: "mt-1",
                progress: 100 * (parseFloat(user.value?.userLeague.betSum.amount)/parseFloat(user.value?.userLeague.nextBetSum.amount))
              }, null, 8, ["progress"])
            ]),
            (user.value?.userLeague.nextDepositsCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('purchases')), 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(numberFormatter).formatNumber(user.value?.userLeague.depositsCount)) + " / " + _toDisplayString(_unref(numberFormatter).formatNumber(user.value?.userLeague.nextDepositsCount)), 1)
                  ]),
                  _createVNode(LeagueProgressBar, {
                    progress: 100*(user.value?.userLeague.depositsCount/user.value?.userLeague.nextDepositsCount),
                    class: "mt-1"
                  }, null, 8, ["progress"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`leagues.short_titles.${user.value?.userLeague.league}`)), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`leagues.short_titles.${user.value?.userLeague.nextLeague}`)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('connected_accounts')), 1)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "subtext" }, "Secure your account and log in faster", -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value?.oauthUsers, (oauth) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("img", {
                  alt: oauth.provider,
                  src: `/img/${oauth.provider.toLowerCase()}.svg`
                }, null, 8, _hoisted_36),
                _createElementVNode("span", _hoisted_37, _toDisplayString(oauth.provider.toLowerCase()), 1)
              ]),
              _createElementVNode("div", null, [
                (oauth.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('connected')), 1))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (connect(oauth.provider)),
                      class: "btn btn-primary"
                    }, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('connect')), 1)
                    ], 8, _hoisted_39))
              ])
            ]))
          }), 256))
        ]),
        _createElementVNode("button", {
          onClick: logout,
          class: "btn btn-outline-danger"
        }, _toDisplayString(_ctx.$t('logout')), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})